import { type WidgetActionHandler } from '../types/WidgetVariant';

import { WidgetActionMethod, type WidgetActions } from '../types/WidgetVariant';

export const createWidgetBaseClient = (namespace: string): WidgetActions =>
  Object.values(WidgetActionMethod).reduce((acc, method) => {
    acc[method as keyof WidgetActions] = (...options: unknown[]) =>
      ((window as unknown as Record<string, unknown>)[namespace] as WidgetActionHandler)(method, ...options);
    return acc;
  }, {} as WidgetActions);
